<!--<template>-->
<!--    <div>-->
<!--        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">-->
<!--            &lt;!&ndash; Left Side &ndash;&gt;-->
<!--            <div class="space-y-6">-->
<!--                &lt;!&ndash; Transfer To Whom Section&ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">TRANSFER TO WHOM?</h3>-->
<!--                    <div class="relative">-->
<!--                        <input-->
<!--                            v-model="searchBeneficiary"-->
<!--                            class="w-full px-4 py-3 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"-->
<!--                            placeholder="Search Beneficiary"-->
<!--                            type="text"-->
<!--                        />-->
<!--                        <svg-->
<!--                            class="absolute left-3 top-3.5 h-4 w-4 text-gray-400"-->
<!--                            fill="none"-->
<!--                            stroke="currentColor"-->
<!--                            viewBox="0 0 24 24"-->
<!--                        >-->
<!--                            <path-->
<!--                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                stroke-width="2"-->
<!--                            />-->
<!--                        </svg>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Beneficiaries List&ndash;&gt;-->
<!--                    <div class="mb-6">-->
<!--                        <BeneficiarySelector-->
<!--                            v-model="selectedBeneficiary"-->
<!--                            :beneficiaries="beneficiaryList"-->
<!--                            @select-beneficiary="onBeneficiarySelected"-->
<!--                            @add-new-beneficiary="openNewBeneficiaryForm"-->
<!--                        />-->
<!--                        <NewBeneficiaryModal :isOpen="isModalOpen" @close="isModalOpen = false"/>-->
<!--                    </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; Account to Credit Section&ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">ACCOUNT TO CREDIT</h3>-->
<!--                    <div class="space-y-4">-->
<!--                        <FloatingLabelInput v-model="iban" input-id="iban-field" label="Account number or IBAN *"/>-->
<!--                        <FloatingLabelInput v-model="beneficiaryBank" input-id="iban-field" label="Beneficiary's Bank *"/>-->
<!--                        <FloatingLabelInput v-model="swiftCode" input-id="swift-field" label="BIC / SWIFT Code *"/>-->
<!--                        <textarea-->
<!--                            v-model="additionalInfo"-->
<!--                            class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"-->
<!--                            placeholder="Additional clearing information information Ex: Sort Code, Fedwire/ABA, etc."-->
<!--                            rows="4"-->
<!--                        ></textarea>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">ADDITIONAL INFORMATION</h3>-->
<!--                    <div class="space-y-4">-->
<!--                        <FloatingLabelInput v-model="intermediaryBankName" input-id="iban-field" label="Intermediary Bank Name"/>-->
<!--                        <FloatingLabelInput v-model="intermediaryBankCode" input-id="iban-field" label="Intermediary Bank Code (BIC)"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; Right Side &ndash;&gt;-->
<!--            <div class="space-y-6">-->
<!--                &lt;!&ndash; Beneficiary Section&ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">Beneficiary</h3>-->
<!--                    <div class="space-y-4">-->
<!--                        <FloatingLabelInput v-model="beneficiaryName" input-id="iban-field" label="Beneficiary name *"/>-->
<!--                        <FloatingLabelInput v-model="beneficiaryAddress" input-id="iban-field" label="Beneficiary Address *"/>-->
<!--                        <FloatingLabelInput input-id="swift-field" label=""/>-->
<!--                        <FloatingLabelInput input-id="swift-field" label=""/>-->
<!--                        <FloatingLabelInput v-model="country" input-id="swift-field" label="Country *"/>-->
<!--                    </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; How Much Section&ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">HOW MUCH?</h3>-->
<!--                    <div class="flex items-center gap-x-2 relative">-->
<!--                        <FloatingLabelInput-->
<!--                            v-model="transferValue"-->
<!--                            class="w-full"-->
<!--                            label="Value *"-->
<!--                            min="0"-->
<!--                            type="number"-->
<!--                        />-->
<!--                        <button class="text-gray-600 bg-gray-200 rounded px-3 py-3" type="button">EUR</button>-->
<!--                    </div>-->

<!--                    <div class="mt-4">-->
<!--                        <FloatingLabelInput v-model="description" input-id="desc-field" label="Description *"/>-->
<!--                    </div>-->

<!--                    <div class="mt-4">-->
<!--                        <FloatingLabelInput input-id="desc-field" label=""/>-->
<!--                    </div>-->

<!--                    <div class="mt-4">-->
<!--                        <FloatingLabelInput input-id="desc-field" label=""/>-->
<!--                    </div>-->

<!--                    <div class="mt-4">-->
<!--                        <FloatingLabelInput input-id="desc-field" label=""/>-->
<!--                    </div>-->

<!--                    <div class="mt-4">-->
<!--                      <textarea-->
<!--                          v-model="paymentReason"-->
<!--                          class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"-->
<!--                          placeholder="Reason for Payment (for Bank use only) *"-->
<!--                          rows="4"-->
<!--                      ></textarea>-->
<!--                    </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; Supporting Documents Section&ndash;&gt;-->
<!--                <div>-->
<!--                    <h3 class="text-sm font-medium text-gray-600 mb-2 tracking-wide">SUPPORTING TRANSFER DOCUMENTS-->
<!--                        (OPTIONAL)</h3>-->
<!--                    <p class="text-sm text-gray-500 mb-4">-->
<!--                        You can upload multiple documents by selecting them one by one-->
<!--                    </p>-->

<!--                    <Transition name="slide-down">-->
<!--                        <div v-if="showDocumentForm" class="flex items-center gap-2 mb-4">-->
<!--                            <div class="w-full space-y-3 transition duration-900">-->
<!--                                <FloatingLabelInput-->
<!--                                    v-model="documentDescription"-->
<!--                                    input-id="doc-desc-field"-->
<!--                                    label="Document description 1 *"-->
<!--                                />-->
<!--                                <FloatingLabelFileInput-->
<!--                                    ref="fileInput"-->
<!--                                    v-model="handleFileSelect"-->
<!--                                    accept=".pdf,.jpg,.jpeg,.png,.bmp"-->
<!--                                    class="mb-4"-->
<!--                                    label="File *"-->
<!--                                />-->
<!--                            </div>-->
<!--                            <button class="p-4 rounded-lg shadow text-red-400 hover:bg-red-50"-->
<!--                                    @click="toggleDocumentForm(false)">-->
<!--                                <component :is="Trash"/>-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </Transition>-->

<!--                    <button-->
<!--                        class="w-full flex items-center justify-center px-4 py-2 border border-orange-500 text-primary rounded-md hover:bg-orange-50 transition-colors"-->
<!--                        @click="toggleDocumentForm(true)"-->
<!--                    >-->
<!--                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                            <path-->
<!--                                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"-->
<!--                                stroke-linecap="round"-->
<!--                                stroke-linejoin="round"-->
<!--                                stroke-width="2"-->
<!--                            />-->
<!--                        </svg>-->
<!--                        Attach Documents-->
<!--                    </button>-->

<!--                    <p class="text-xs text-gray-400 mt-2">Allowed file formats: pdf, jpg, bmp</p>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; Buttons &ndash;&gt;-->
<!--        <div class="flex justify-center gap-x-3 mt-10">-->
<!--            <button-->
<!--                class="flex w-1/4 items-center justify-center gap-x-2 text-primary bg-white text-sm font-semibold py-2 px-6 rounded-md transition-colors text-lg tracking-wide shadow-md">-->
<!--                <component :is="Star" class="w-5 h-5"/>-->
<!--                Save Beneficiary-->
<!--            </button>-->

<!--            <button-->
<!--                class="w-1/4 bg-primary text-white font-semibold py-2 px-6 rounded-md transition-colors text-lg tracking-wide shadow-md"-->
<!--                @click="submitTransfer()"-->
<!--            >-->
<!--                TRANSFER-->
<!--            </button>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import {ref} from "vue";-->
<!--import FloatingLabelInput from '@/components/ui/FloatingLabelInput.vue';-->
<!--import FloatingLabelFileInput from '@/components/ui/FloatingLabelFileInput.vue';-->
<!--import BeneficiarySelector from '@/components/transfer/BeneficiarySelector.vue';-->
<!--import {Star, Trash} from 'lucide-vue-next';-->
<!--import NewBeneficiaryModal from "@/components/transfer/NewBeneficiaryModal.vue";-->

<!--// Props یا Emit ها هم اگر خواستی اینجا اضافه کن-->
<!--const searchBeneficiary = ref("");-->
<!--const isModalOpen = ref(false);-->
<!--const iban = ref("");-->
<!--const beneficiaryBank = ref("");-->
<!--const swiftCode = ref("");-->
<!--const beneficiaryName = ref("");-->
<!--const beneficiaryAddress = ref("");-->
<!--const country = ref("");-->
<!--const transferValue = ref("");-->
<!--const description = ref("");-->
<!--const additionalInfo = ref("");-->
<!--const intermediaryBankName = ref("");-->
<!--const intermediaryBankCode = ref("");-->
<!--const transferNature = ref("");-->
<!--const showDocumentForm = ref(false);-->
<!--const documentDescription = ref("");-->
<!--const paymentReason = ref("");-->
<!--const handleFileSelect = ref(null);-->

<!--const toggleDocumentForm = (value) => {-->
<!--    showDocumentForm.value = value;-->
<!--};-->

<!--const selectedBeneficiary = ref({})-->
<!--const beneficiaryList = ref([-->
<!--    {id: 1, name: 'Sarah Wilson', initials: 'SW'}-->
<!--])-->

<!--const onBeneficiarySelected = (beneficiary) => {-->
<!--    selectedBeneficiary.value = beneficiary;-->
<!--};-->

<!--const openNewBeneficiaryForm = () => {-->
<!--    isModalOpen.value = true;-->
<!--};-->

<!--const submitTransfer = () => {-->
<!--    console.log('Transfer submitted with data:', {-->
<!--        searchBeneficiary: searchBeneficiary.value,-->
<!--        transferValue: transferValue.value,-->
<!--        description: description.value,-->
<!--        additionalInfo: additionalInfo.value,-->
<!--        transferNature: transferNature.value,-->
<!--        iban: iban.value,-->
<!--        swiftCode: swiftCode.value,-->
<!--        beneficiaryBank: beneficiaryBank.value,-->
<!--        beneficiaryName: beneficiaryName.value,-->
<!--        beneficiaryAddress: beneficiaryAddress.value,-->
<!--        country: country.value,-->
<!--        intermediaryBankName: intermediaryBankName.value,-->
<!--        intermediaryBankCode: intermediaryBankCode.value,-->
<!--        paymentReason: paymentReason.value,-->
<!--        documentDescription: documentDescription.value,-->
<!--    })-->
<!--}-->

<!--</script>-->

<!--<style scoped>-->
<!--.slide-down-enter-active,-->
<!--.slide-down-leave-active {-->
<!--    transition: all 0.3s ease;-->
<!--}-->

<!--.slide-down-enter-from,-->
<!--.slide-down-leave-to {-->
<!--    transform: translateY(-10px);-->
<!--    opacity: 0;-->
<!--}-->
<!--</style>-->


<template>
  <div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Left Side -->
      <div class="space-y-6">
        <!-- Transfer To Whom Section-->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">TRANSFER TO WHOM?</h3>
          <div class="relative">
            <input
                v-model="searchBeneficiary"
                @input="debouncedSearch"
                class="w-full px-4 py-3 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                placeholder="Search Beneficiary"
                type="text"
            />
            <svg
                class="absolute left-3 top-3.5 h-4 w-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
              <path
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
              />
            </svg>
          </div>

          <div class="mb-6">
            <BeneficiarySelector
                v-model="selectedBeneficiary"
                :beneficiaries="beneficiaryList"
                @select-beneficiary="onBeneficiarySelected"
                @add-new-beneficiary="openNewBeneficiaryForm"
            />
            <NewBeneficiaryModal :isOpen="isModalOpen" @close="isModalOpen = false"/>
          </div>
        </div>

        <!-- Account to Credit Section-->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">ACCOUNT TO CREDIT</h3>
          <div class="space-y-4">
            <FloatingLabelInput v-model="iban" input-id="iban-field" label="Account number or IBAN *"/>
            <FloatingLabelInput v-model="beneficiaryBank" input-id="iban-field" label="Beneficiary's Bank *"/>
            <FloatingLabelInput v-model="swiftCode" input-id="swift-field" label="BIC / SWIFT Code *"/>
            <textarea
                v-model="additionalInfo"
                class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"
                placeholder="Additional clearing information (Ex: Sort Code, Fedwire/ABA, etc.)"
                rows="4"
            ></textarea>
          </div>
        </div>

        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">ADDITIONAL INFORMATION</h3>
          <div class="space-y-4">
            <FloatingLabelInput v-model="intermediaryBankName" input-id="iban-field" label="Intermediary Bank Name"/>
            <FloatingLabelInput v-model="intermediaryBankCode" input-id="iban-field" label="Intermediary Bank Code (BIC)"/>
          </div>
        </div>
      </div>

      <!-- Right Side -->
      <div class="space-y-6">
        <!-- Beneficiary Section-->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">Beneficiary</h3>
          <div class="space-y-4">
            <FloatingLabelInput v-model="beneficiaryName" input-id="iban-field" label="Beneficiary name *"/>
            <FloatingLabelInput v-model="beneficiaryAddress" input-id="iban-field" label="Beneficiary Address *"/>
            <FloatingLabelInput input-id="swift-field" label=""/>
            <FloatingLabelInput input-id="swift-field" label=""/>
            <FloatingLabelInput v-model="country" input-id="swift-field" label="Country *"/>
          </div>
        </div>

        <!-- How Much Section-->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-4 tracking-wide">HOW MUCH?</h3>
          <div class="flex items-center gap-x-2 relative">
            <FloatingLabelInput
                v-model="transferValue"
                class="w-full"
                label="Value *"
                min="0"
                type="number"
            />
            <button class="text-gray-600 bg-gray-200 rounded px-3 py-3" type="button">EUR</button>
          </div>

          <div class="mt-4">
            <FloatingLabelInput v-model="description" input-id="desc-field" label="Description *"/>
          </div>

          <div class="mt-4">
            <FloatingLabelInput v-model="paymentReason" input-id="desc-field" label="Reason for Payment (Bank Use)"/>
          </div>
        </div>

        <!-- Supporting Documents Section-->
        <div>
          <h3 class="text-sm font-medium text-gray-600 mb-2 tracking-wide">SUPPORTING TRANSFER DOCUMENTS (OPTIONAL)</h3>
          <p class="text-sm text-gray-500 mb-4">You can upload multiple documents one by one</p>

          <div v-if="attachedDocuments.length > 0" class="mb-4 space-y-2">
            <div v-for="(doc, index) in attachedDocuments" :key="index" class="flex items-center justify-between bg-gray-50 px-3 py-2 rounded">
              <div class="flex-1 mr-2">
                <p class="text-gray-700 text-sm font-medium">{{ doc.file.name }}</p>
                <input v-model="doc.description" type="text" class="w-full mt-1 px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Document description"/>
              </div>
              <button type="button" class="text-red-500 px-2 py-1 rounded hover:bg-red-50" @click="removeDocument(index)">
                <component :is="Trash" class="w-5 h-5"/>
              </button>
            </div>
          </div>

          <Transition name="slide-down">
            <div v-if="showDocumentForm" class="flex items-center gap-2 mb-4">
              <div class="w-full space-y-3 transition duration-900">
                <FloatingLabelInput v-model="documentDescription" input-id="doc-field" label="Document description"/>
                <div class="relative">
                  <FloatingLabelFileInput
                      ref="fileInput"
                      @change="handleFileSelect"
                      accept=".pdf,.jpg,.jpeg,.png,.bmp"
                      class="mb-4"
                      label="Select File"
                  />
                </div>
              </div>
              <button class="p-4 rounded-lg shadow text-red-400 hover:bg-red-50" @click="toggleDocumentForm(false)">
                <component :is="Trash"/>
              </button>
            </div>
          </Transition>

          <button class="w-full flex items-center justify-center px-4 py-2 border border-orange-500 text-primary rounded-md hover:bg-orange-50 transition-colors" @click="toggleDocumentForm(true)">
            Attach Documents
          </button>
          <p class="text-xs text-gray-400 mt-2">Allowed file formats: pdf, jpg, jpeg, png, bmp</p>
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-center gap-x-3 mt-10">
      <button class="flex w-1/4 items-center justify-center gap-x-2 text-primary bg-white text-sm font-semibold py-2 px-6 rounded-md transition-colors text-lg tracking-wide shadow-md">
        <component :is="Star" class="w-5 h-5"/>
        Save Beneficiary
      </button>

      <button class="w-1/4 bg-primary text-white font-semibold py-2 px-6 rounded-md transition-colors text-lg tracking-wide shadow-md" @click="submitTransfer()">
        TRANSFER
      </button>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import FloatingLabelInput from '@/components/ui/FloatingLabelInput.vue';
import FloatingLabelFileInput from '@/components/ui/FloatingLabelFileInput.vue';
import BeneficiarySelector from '@/components/transfer/BeneficiarySelector.vue';
import NewBeneficiaryModal from "@/components/transfer/NewBeneficiaryModal.vue";
import {Star, Trash} from 'lucide-vue-next';
import api from '@/services/api';
import debounce from 'lodash/debounce';

// Form fields
const searchBeneficiary = ref("");
const isModalOpen = ref(false);
const iban = ref("");
const beneficiaryBank = ref("");
const swiftCode = ref("");
const beneficiaryName = ref("");
const beneficiaryAddress = ref("");
const country = ref("");
const transferValue = ref("");
const description = ref("");
const additionalInfo = ref("");
const intermediaryBankName = ref("");
const intermediaryBankCode = ref("");
const paymentReason = ref("");
const showDocumentForm = ref(false);
const documentDescription = ref("");
const attachedDocuments = ref([]);

const toggleDocumentForm = (value) => showDocumentForm.value = value;

// Beneficiaries
const selectedBeneficiary = ref({})
const beneficiaryList = ref([])
const onBeneficiarySelected = (beneficiary) => {
  selectedBeneficiary.value = beneficiary;
  // Pre-fill fields
  iban.value = beneficiary.iban || '';
  swiftCode.value = beneficiary.swift || '';
  beneficiaryName.value = beneficiary.name || '';
  beneficiaryAddress.value = beneficiary.address || '';
};
const openNewBeneficiaryForm = () => isModalOpen.value = true;

// Debounced search
const searchBeneficiaries = async () => {
  try {
    if(searchBeneficiary.value.length < 2) { beneficiaryList.value = []; return; }
    const res = await api.get('/beneficiaries/search', {
      params: { q: searchBeneficiary.value, account_type: 'international' },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    console.log("ben",res.data);
    beneficiaryList.value = res.data;
  } catch(e) { console.error(e); }
};
const debouncedSearch = debounce(searchBeneficiaries, 300);

// File handling
const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if(!file) return;
  attachedDocuments.value.push({ file, description: documentDescription.value || '' });
  documentDescription.value = '';
  showDocumentForm.value = false;
};
const removeDocument = (index) => attachedDocuments.value.splice(index,1);

// Submit
const submitTransfer = () => {
  // Validate required fields
  let missing = [];
  if(!iban.value) missing.push('IBAN');
  if(!swiftCode.value) missing.push('SWIFT');
  if(!beneficiaryName.value) missing.push('Beneficiary Name');
  if(!transferValue.value) missing.push('Value');
  if(!description.value) missing.push('Description');
  if(missing.length) {
    alert("Please fill: " + missing.join(", "));
    return;
  }

  // Prepare data
  const data = {
    iban: iban.value,
    swift: swiftCode.value,
    beneficiaryBank: beneficiaryBank.value,
    beneficiaryName: beneficiaryName.value,
    beneficiaryAddress: beneficiaryAddress.value,
    country: country.value,
    transferValue: transferValue.value,
    description: description.value,
    additionalInfo: additionalInfo.value,
    intermediaryBankName: intermediaryBankName.value,
    intermediaryBankCode: intermediaryBankCode.value,
    paymentReason: paymentReason.value,
    attachments: attachedDocuments.value
  };
  console.log("Submitting transfer:", data);
};


</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active { transition: all 0.3s ease; }
.slide-down-enter-from,
.slide-down-leave-to { transform: translateY(-10px); opacity: 0; }
</style>

